<div class="fileUpload">
    <input (change)="emitFile($event.target.files)"
           [accept]="[acceptedFileTypes.join(','), acceptedFileExtensions.join(',')].join(',')"
           [id]="'upload' + id"
           type="file"
           #fileUpload>
    <label [htmlFor]="'upload' + id">
        <span [i18n]="labelKey"></span>
    </label>
</div>